import MuiSelectHorizontal from './MuiSelectHorizontal';

export default MuiSelectHorizontal;
